import React from 'react'
import DashboardMaster from '../../../../../dashboard/DashboardMaster'
import TenureDetailsContents from './TenureDetailsContents'

const TenureDetails = () => {
  return (
    <DashboardMaster>
      <TenureDetailsContents />
    </DashboardMaster>
  )
}

export default TenureDetails